import { render, staticRenderFns } from "./InfoLayout.vue?vue&type=template&id=4d0f81f3&scoped=true&"
import script from "./InfoLayout.vue?vue&type=script&setup=true&lang=ts&"
export * from "./InfoLayout.vue?vue&type=script&setup=true&lang=ts&"
import style0 from "./InfoLayout.vue?vue&type=style&index=0&id=4d0f81f3&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d0f81f3",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/prodoctorov/pd-ssr/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4d0f81f3')) {
      api.createRecord('4d0f81f3', component.options)
    } else {
      api.reload('4d0f81f3', component.options)
    }
    module.hot.accept("./InfoLayout.vue?vue&type=template&id=4d0f81f3&scoped=true&", function () {
      api.rerender('4d0f81f3', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/layouts/info-pages/InfoLayout.vue"
export default component.exports